export class Rol {
  constructor(
    public readonly Id: number,
    public readonly Codigo: string | null,
    public readonly Nombre: string | null,
    public readonly Activo: boolean,
    public readonly EsDefaultParaAltas: boolean,
    public readonly RolTipoId: number | null,
    public readonly RolTipoNombre: string | null,
    public readonly TenantId: number,
    public readonly Funciones: RolMenuFuncion[],
    public readonly TiposMensaje: RolMensajeUsuarioTipo[],
    public readonly OpcionesEnvioMensaje: RolMensajeUsuarioOpcionEnvio[]
  ) {}
}

export class RolMenuFuncion {
  constructor(
    public readonly RolId: number,
    public readonly MenuFuncionId: number,
    public readonly Id: number
  ){}
}

export class RolMensajeUsuarioTipo {
  constructor(
    public readonly RolId: number,
    public readonly MensajeUsuarioTipoId: number,
    public readonly Id: number
  ){}
}

export class RolMensajeUsuarioOpcionEnvio {
  constructor(
    public readonly Id: number,
    public readonly RolId: number,
    public readonly MensajeUsuarioOpcionEnvioId: number,
    public readonly EsRecepcion: boolean
  ){}
}

export class SearchRolRequest {
  constructor(
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string | null,
    public readonly Nombre: string | null,
    public readonly Codigo: string | null,
    public readonly TenantId: number | null,
    public readonly VerSoloActivos: boolean | null
  ) {}
}

export class SearchRolResponse {
  constructor(
    public readonly count: number,
    public readonly result: Rol[]
  ) {}
}

export class SaveRolDto {
  constructor(
    public readonly Id: number | null,
    public readonly Codigo: string | null,
    public readonly Nombre: string | null,
    public readonly RolTipoId: number | null,
    public readonly EsDefaultParaAltas: boolean,
    public readonly Activo: boolean,
    public readonly Menues: number[],
    public readonly OpcionesEnvioMensaje: number[],
    public readonly OpcionesRecepcionMensaje: number[],
    public readonly TiposMensaje: number[]
  ) {}
}

export enum PedidoComunidadRolEnum
{
  CEO = "CEO",
  COORDINADOR = "COORDINADOR",
  COORDINADOR_GRAL = "COORDINADOR_GRAL",
  JEFE_OBRA = "JEFE_OBRA"
}
